import 'vuetify/styles';
import {createVuetify} from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

export const vuetify = createVuetify({
    defaults: {
        global: {
            ripple: false,
        }
    },
    ssr: true,
    components,
    directives,
    theme: {
        themes: {
            light: {
                dark: false,
                colors: {
                    primary: '#0D87EF',
                    'third-blue-color': '#E7F3FD',
                    secondary: '#FFFFFF',
                    accent: '#363636',
                    error: '#F02849',
                    warning: '#FF8800',
                    'warning-background': '#FEFFE5',
                    info: '#0D87EF',
                    success: '#05A660',
                    BG: '#F6F6F6',
                    'BW-200': '#F0F3F4',
                    'BW-100-BG': '#F6F7F8',
                    'BW-400-Border': '#CED4DA',
                    'BW-State-Colors-green-1-bg-success': '#E3F5E8',
                    'BW-600-gray-text': '#6C757D',
                    'BW-500': '#8D959D'
                }
            }
        }
    }
});
